import axios from "axios";

const RESEARCHER_DASHBOARD_SERVICE = process.env.REACT_APP_RESEARCHER_DASHBOARD_MICROSERVICE_URL +  process.env.REACT_APP_SERVICES_VERSION;

export default function ResearcherDashboardService() {
}

/**
 * getOrganisations
 *
 * @returns {map}
 */
 export async function getOrganisations() {

    const url = RESEARCHER_DASHBOARD_SERVICE + '/researcherdashboardservice/institutions' ;
    const organisationsList = axios.create({ baseURL: url });

    const organisations = await organisationsList.get('')
        .then(response => {
            const data = response.data.response.success
            return data;
        })
        .catch((e) => {
            console.error('There was an error!', e);
        });

    return null;
}
 
/**
* getCorrespondentsStatus
* @param {long} 
* @returns {[map]}
*/
export async function getCorrespondentsStatus(surveyCycleId) {
    const url = RESEARCHER_DASHBOARD_SERVICE + '/researcherdashboardservice/correspondents/surveycycle/' + surveyCycleId;
    const correspondentsURL = axios.create({ baseURL: url });

    const correspondents = await correspondentsURL.get('')
        .then(response => {
            const data = response.data.response.success
            return data;
        })
        .catch((e) => {
            console.error('There was an error!', e);
        });

    if (correspondents !== undefined && correspondents !== null) {
        return correspondents;
    }

    return null;
}